import {
  RESET,
  SET_PAGE,
  SET_TOTAL_PAGES,
  SET_SEARCH,
  SET_LIMIT,
  SET_FILTERS,
  SET_ORDERS
} from "../../utils/constants";

const initialState = () => ({});

const state = {
  ...initialState(),
  params: {
    search: null,
    limit: 25,
    page: 1
  },
  filters: {},
  orders: {},
  orderValues: [
    { title: "Nincs rendezés", order: null },
    { title: "Csökkenő sorrend", order: "desc" },
    { title: "Növekvő sorrend", order: "asc" }
  ],
  totalPages: 0,
  limitDropdown: [10, 25, 50, 100]
};

const getters = {};

Object.keys(state).forEach(key => {
  Object.assign(getters, {
    [key]: state => state[key]
  });
});

const actions = {
  rowsLoaded({ commit }, { last_page }) {
    commit(SET_TOTAL_PAGES, last_page);
  }
};

const mutations = {
  [RESET](state) {
    Object.assign(state, initialState());
  },
  [SET_PAGE](state, payload) {
    state.params.page = payload;
  },
  [SET_TOTAL_PAGES](state, payload) {
    state.totalPages = payload;
  },
  [SET_SEARCH](state, payload) {
    state.params.search = payload;
  },
  [SET_LIMIT](state, payload) {
    state.params.limit = payload;
  },
  [SET_FILTERS](state, payload) {
    state.params.page = 1;
    state.filters = { ...payload };
  },
  [SET_ORDERS](state, payload) {
    state.orders = { ...payload };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
